import { BaseProperties } from "./base.interface";
import { FilesOutput } from "./files";
import { TagsOutput } from "./tags";

export enum AdditionalItemType {
  PRODUCT = "PRODUCT",
  CUSTOM = "CUSTOM",
}

export enum AdditionalSelectionType {
  RADIO = "RADIO",
  CHECKBOX = "CHECKBOX",
  NUMBER = "NUMBER",
}

export interface ProductAdditionalItem {
  id?: string;
  name: string;
  unitPrice: number;
  unitCost: number;
  productId?: string | null;
  fileId?: string | null;
  type?: AdditionalItemType;
  consumptionFactor?: number;
}

export interface ProductAdditional {
  id?: string;
  name: string;
  selectionType: AdditionalSelectionType;
  minQuantity: number;
  maxQuantity: number;
  items: ProductAdditionalItem[];
}

export interface ProductAdditionalGroupRequest {
  name: string;
  selectionType: AdditionalSelectionType;
  minQuantity: number;
  maxQuantity: number;
  position: number;
}

export interface ProductAdditionalItemRequest {
  label: string;
  unitPrice: number;
  unitCost: number;
  consumptionFactor: number;
  position: number;
  productId: string | null;
  fileId?: string | null;
}

export interface ProductAdditionalGroupResponse
  extends ProductAdditionalGroupRequest {
  id: string;
  items: ProductAdditionalItemResponse[];
}

export interface ProductAdditionalItemResponse
  extends ProductAdditionalItemRequest {
  id: string;
}

export interface ProductsInput {
  name: string;
  description: string;
  unitPrice: number;
  unitCost: number;
  fileId?: string | null;
  tags?: string[];
  additional?: ProductAdditional[];
}

export interface ProductsOutput
  extends BaseProperties,
    Omit<ProductsInput, "tags"> {
  tags?: string[] | TagsOutput[];
  file?: FilesOutput;
  additional?: ProductAdditional[];
}
